import { onLikeNews } from "@core-shop/models/news";
import { OnLikeNewsMutationVariables } from "@core-shop/types";

export const newsMutations = {
  onLikeNews: () => ({
    mutationFn: (variables: OnLikeNewsMutationVariables) => onLikeNews(variables),
  }),
} as const;
